import { AxiosError } from 'axios';

import { sendServiceEvent } from '@/shared/api/api';
import {
  getCurrentSRC,
  getHeight,
  getHostname,
  getWidth,
} from '@/shared/helpers/environment/helpers';
import { getErrorMessage } from '@/shared/helpers/get-error-message';

import { type ServiceEvent, ServiceEventType, type ServiceLoggerOptions } from './types';

export const LIB_NAME = 'MARKET';

export class ServiceLogger {
  private predefinedOptions: ServiceLoggerOptions;

  constructor(options: ServiceLoggerOptions) {
    this.predefinedOptions = options;
  }

  logError(
    error: string | Error | AxiosError,
    place: string,
    extra?: Record<string, string>
  ): void {
    const payload: ServiceEvent = {
      type: ServiceEventType.ERROR,
      message: getErrorMessage(error),
      stacktrace: (typeof error === 'object' ? error : {})?.stack ?? '',
      tags: {
        d_mod: this.predefinedOptions.d_mod,
        d_os: this.predefinedOptions.d_os,
        d_p: this.predefinedOptions.d_p,
        tg_id: this.predefinedOptions.tg_id,
        lib_n: this.predefinedOptions.lib_n,
        lib_v: this.predefinedOptions.lib_v,
      },
      extra: {
        loc: this.predefinedOptions.loc,
        hn: getHostname(),
        br_w: getWidth(),
        br_h: getHeight(),
        src: getCurrentSRC(),
        place: place,
        ...(error instanceof AxiosError && {
          r_url: error.config?.url,
          r_data: error.config?.data,
        }),
        ...extra,
      },
    };

    sendServiceEvent(payload);
  }
}
